import { SpinnerMedium } from '@tmov/design-system/icons';
import PropTypes from 'prop-types';
import React from 'react';

import { LoadingContainer } from '../../../../../components/LoadingContainer';
import { Container, Content, Title } from './styles';

const Card = ({ title, content, children, loading }) => (
  <Container>
    {!loading ? (
      <>
        {title && <Title>{title}</Title>}
        {content && <Content>{content}</Content>}
        {children}
      </>
    ) : (
      <LoadingContainer>
        <SpinnerMedium />
      </LoadingContainer>
    )}
  </Container>
);

export default Card;

Card.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
};

Card.defaultProps = {
  title: '',
  content: '',
  children: null,
  loading: false,
};
